import './styles.css';

export default function Slider({
    min = 1,
    max = 20,
    value = 5,
    onChange,
    disabled = false,
    label = "",
    className = ""
}) {
    const handleChange = (e) => {
        if (onChange) {
            onChange(Number(e.target.value));
        }
    };

    return (
        <div className={`slider-wrapper ${className}`}>
            <div className="slider-container">
                <input
                    type="range"
                    min={min}
                    max={max}
                    value={value}
                    onChange={handleChange}
                    disabled={disabled}
                    className="slider-input"
                />
                <span className="slider-value">{value}</span>
            </div>
            {label && <span className="slider-legend">{label}</span>}
        </div>
    );
}
